var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-content-body"},_vm._l((_vm.buttonList),function(button,buttonIndex){return _c('el-button',{key:buttonIndex,attrs:{"type":button.type,"loading":_vm.loadingState[button['loading']],"size":"mini"},on:{"click":function($event){return button.fun(_vm.marker)}}},[_vm._v(_vm._s(button.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }